import { memo } from "react";
import { useTranslate } from "helpers";
import { MESSAGE_TEMPLATE_TAGS } from "services/api/notifications/consts";
import { TextField } from "ui/components/TextField/TextField";
import { TemplateEditor } from "ui/components/TemplateEditor/TemplateEditor";

interface Props {
  title: string;
  messageTemplate: string;
  errors: Record<string, any>;
  onFieldChange: (e: any) => void;
}

const MessageContentSection: React.FC<Props> = ({ title, messageTemplate, errors, onFieldChange }) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="block text-sm font-medium text-gray-700 ">Sadržaj poruke</div>

      <div className="border border-dashed border-blue-300 px-4 pt-4 pb-5 mb-3 rounded-sm bg-slate-50">
        <p className="text-sm text-slate-500 mb-2">
          Unesite naziv i predložak poruke koji će primatelji dobivati preko odabranih kanala.
        </p>
        <div className="flex-1 mb-3">
          <TextField
            type="text"
            name="title"
            label={t("admin.notification.field.title")}
            value={title}
            onChange={onFieldChange}
            error={errors.title}
            required
            width="full"
            cssClassName="bg-white"
          />
        </div>
        <div className="flex-1">
          <TemplateEditor
            name="messageTemplate"
            label={t("admin.notification.field.messageTemplate")}
            value={messageTemplate}
            onChange={onFieldChange}
            tags={MESSAGE_TEMPLATE_TAGS}
            error={errors.messageTemplate}
            required
            rows={4}
            cssClassName="bg-white"
          />
        </div>
      </div>
    </>
  );
};

export default memo(MessageContentSection);
